<template>
  <div class="modal-fullscreen slp-profile">
    <div class="modal" v-if="step === 0">
      <div class="btn-close-container">
        <div class="btn-close" @click="close"></div>
      </div>
      <h1>Wählen Sie einen Profil-Typ aus</h1>
      <div class="group-wrapper category big">
        <div
          v-for="(p, idx) in profileCategories"
          :key="p.id"
          class="item-wrapper"
          @click="select(p, idx)"
        >
          <div class="img-wrapper">
            <img v-bind:src="getImgUrl(p.img)" class="icon" />
          </div>
          <h2>{{ p.label }}</h2>
          <div class="description">
            {{ p.description }}
          </div>
          <button @click="nextStep(1, p)">Profil erstellen</button>
        </div>
      </div>
    </div>
    <div class="modal" v-if="step === 1">
      <div class="pull-left" @click="goBackToStep(step)">
        <img class="btn-back" src="../assets/img/left-arrow.svg" />
      </div>
      <div
        class="btn-close-container"
        :class="{ 'step-one': selectedCategory == 'REP' }"
      >
        <div class="btn-close" @click="close"></div>
      </div>
      <h1>Wählen Sie einen Profil-Typ aus</h1>
      <div class="group-wrapper category big">
        <div
          v-for="(slp, idx) in SLPCategories"
          :key="slp.id"
          class="item-wrapper"
          @click="select(slp, idx)"
        >
          <div class="img-wrapper">
            <img :src="getImgUrl(slp.img)" class="icon" />
          </div>
          <h2>{{ slp.label }}</h2>
          <div class="description">
            {{ slp.description }}
          </div>
          <button @click="nextStep(2, slp)">
            {{ slp.name }}
          </button>
        </div>
      </div>
    </div>
    <div class="modal" v-if="step === 2">
      <div class="pull-left" @click="goBackToStep(step)">
        <img class="btn-back" src="../assets/img/left-arrow.svg" />
      </div>
      <div
        class="btn-close-container"
        :class="{ 'step-one': selectedCategory == 'REP' }"
      >
        <div class="btn-close" @click="close"></div>
      </div>
      <div
        v-if="selectedCategory == 'SLP' && slpSelectedCategory == 'Gasprofil'"
        class="consumption profiles"
      >
        <h1>Parameter eingeben</h1>
        <form>
          <!-- Kundentyp -->
          <div
            v-if="selectedCategory == 'SLP'"
            class="input-group position-relative"
          >
            <label>Kundentyp</label>
            <input
              class="input-disable input-data"
              placeholder="Kundentyp"
              v-model="customerTypeData.name"
              @click="customOptionSelect('customertype')"
              :disabled="disableType.customerTypeData"
            />

            <div
              class="toggle-list-wrapper data-fields"
              v-if="showOption === 'customertype'"
            >
              <div
                v-for="(f, index) in customDataFiltered(
                  'customertype',
                  customerTypes,
                  customerTypeFilter
                )"
                :key="index"
                class="item"
                @click="customDropDownFunction(f, 'Kundentyp')"
              >
                <div class="label">{{ f.name }}</div>
              </div>
            </div>
          </div>
          <!--Bundesland  -->
          <div
            v-if="selectedCategory == 'SLP'"
            class="input-group position-relative"
          >
            <label>Bundesland</label>
            <input
              class="input-disable input-data"
              placeholder="Bundesland"
              v-model="BundeslandData.name"
              @click="customOptionSelect('Bundesland')"
              :disabled="disableType.bundlesData"
            />
            <div
              class="toggle-list-wrapper data-fields"
              v-if="showOption === 'Bundesland'"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input name="search" v-model="BundeslandFilter" />
              </div>
              <div
                v-for="(f, index) in customDataFiltered(
                  'Bundesland',
                  BundeslandTypes,
                  BundeslandFilter
                )"
                :key="index"
                class="item"
                @click="customDropDownFunction(f, 'Bundesland')"
              >
                <div class="label">{{ f.name }}</div>
              </div>
            </div>
          </div>
          <!-- Profiltyp -->
          <div class="input-group position-relative">
            <label>Profiltyp</label>
            <input
              class="input-disable input-data"
              placeholder="Profiltyp"
              v-model="profileTypeData.caption"
              @click="customOptionSelect('profiletype')"
              :disabled="disableType.profileTypeData"
            />
            <div
              class="toggle-list-wrapper data-fields"
              v-if="showOption === 'profiletype'"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input name="search" v-model="profileTypeFilter" />
              </div>
              <div
                v-for="(f, index) in customDataFiltered(
                  'profile',
                  profileTypes,
                  profileTypeFilter
                )"
                :key="index"
                class="item"
                @click="customDropDownFunction(f, 'Profiltyp')"
              >
                <div class="label">{{ f.caption }}</div>
              </div>
            </div>
          </div>

          <!-- Windstärke/Heizung  -->

          <div class="input-group position-relative">
            <label>Windstärke/Heizung</label>
            <input
              class="input-disable input-data"
              placeholder="Windstärke/Heizung"
              v-model="windTypeData.name"
              @click="customOptionSelect('wind')"
              :disabled="disableType.windData"
            />
            <div
              class="toggle-list-wrapper data-fields"
              v-if="showOption === 'wind'"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input name="search" v-model="windTypeDataFilter" />
              </div>
              <div
                v-for="(f, index) in customDataFiltered(
                  'wind',
                  windTypes,
                  windTypeDataFilter
                )"
                :key="index"
                class="item"
                @click="customDropDownFunction(f, 'Windstärke/Heizung')"
              >
                <div class="label">{{ f.name }}</div>
              </div>
            </div>
          </div>
          <!-- Frequenz -->
          <div class="input-group position-relative">
            <label>Frequenz</label>
            <input
              class="input-disable input-data"
              placeholder="Frequenz"
              v-model="frequencyTypeData.name"
              @click="customOptionSelect('freq')"
              :disabled="disableType.frequencyTypeData"
            />
            <div
              class="toggle-list-wrapper data-fields"
              v-if="showOption === 'freq'"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input name="search" v-model="frequencyTypeFilter" />
              </div>
              <div
                v-for="(f, index) in customDataFiltered(
                  'freq',
                  frequencyTypes,
                  frequencyTypeFilter
                )"
                :key="index"
                class="item"
                @click="customDropDownFunction(f, 'Frequenz')"
              >
                <div class="label">{{ f.name }}</div>
              </div>
            </div>
          </div>
        </form>

        <div class="footer">
          <button @click="getSlpTypeData()">weiter</button>
        </div>
      </div>
      <div
        v-else-if="
          selectedCategory == 'SLP' && slpSelectedCategory == 'Stromprofil'
        "
        class="consumption profiles"
      >
        <h1>Kundenprofil auswählen</h1>
        <h2>Wähle das passende Verbrauchsprofil und klicke auf weiter.</h2>
        <div
          class="group-wrapper customer-profile fancy-scroll"
          @scroll.passive="showScrollbar"
        >
          <div
            v-for="(p, idx) in slpProfileTypes"
            :key="p.id"
            class="item-wrapper"
            v-bind:class="{ active: p.selected }"
            @click="select(p, idx)"
          >
            <div class="img-wrapper">
              <img v-bind:src="getImgUrl(p.img)" class="icon" />
            </div>
            <h2>{{ p.label }}</h2>
            <div class="description">
              {{ p.description }}
            </div>
          </div>
        </div>
        <div class="footer">
          <button
            @click="nextStep(3, null)"
            :disabled="selectedSLP == null"
            v-bind:class="{ disabled: selectedSLP == null }"
          >
            Weiter
          </button>
        </div>
      </div>
      <div v-else class="generator profiles">
        <h1>Erzeugungsprofil auswählen</h1>
        <h2>
          Wählen Sie das passende Erzeugungsprofil und klicken Sie auf weiter.
        </h2>
        <div class="group-wrapper">
          <div
            v-for="(p, idx) in generatorProfiles"
            :key="p.id"
            class="item-wrapper"
            v-bind:class="{ active: p.selected }"
            @click="select(p, idx)"
          >
            <div class="img-wrapper">
              <img v-bind:src="getImgUrl(p.img)" class="icon" />
            </div>
            <h2>{{ p.label }}</h2>
            <div class="description">
              {{ p.description }}
            </div>
          </div>
        </div>
        <div class="footer">
          <button
            @click="nextStep(3, null)"
            :disabled="selectedREP == null"
            v-bind:class="{ disabled: selectedREP == null }"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
    <div
      class="modal"
      :class="{ 'custom-loading': isLoading }"
      v-if="step === 3"
    >
      <LoadingSpinner v-show="isLoading" />
      <div class="btn-close-container">
        <div class="btn-close" @click="close"></div>
      </div>
      <div class="pull-left" @click="goBackToStep(step)">
        <img class="btn-back" src="../assets/img/left-arrow.svg" />
      </div>
      <h1>Parameter eingeben</h1>
      <div
        v-if="slpSelectedCategory == 'Stromprofil' || selectedCategory == 'REP'"
      >
        <form>
          <div class="input-group">
            <label>Name</label>
            <input
              class="input-data"
              type="text"
              placeholder="Name"
              v-model="profileName"
            />
          </div>
          <div v-if="selectedCategory == 'SLP'" class="input-group">
            <label>Jahr</label>
            <input
              class="input-data"
              type="number"
              placeholder="Jahr"
              v-model="year"
            />
          </div>
          <div
            v-if="selectedCategory == 'SLP'"
            class="input-group position-relative"
          >
            <label>Feiertagskalender</label>
            <input
              placeholder="Bundesland"
              class="input-data"
              v-model="state.name"
              @click="showSelectState"
            />
            <div
              class="toggle-list-wrapper data-fields"
              v-show="selectStateVisible"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input name="search" v-model="statesFilter" />
              </div>
              <div
                v-for="(f, index) in customDataFiltered(
                  'states',
                  states,
                  statesFilter
                )"
                :key="index"
                class="item"
                @click="setState(f)"
              >
                <div class="label">{{ f.name }}</div>
              </div>
            </div>
          </div>
          <div v-if="selectedCategory == 'REP'" class="input-group">
            <label>Start</label>
            <input type="datetime-local" class="input-data1" v-model="start" />
          </div>
          <div v-if="selectedCategory == 'REP'" class="input-group">
            <label>Ende</label>
            <input
              type="datetime-local"
              max="2027-09-30T00:00"
              class="input-data1"
              v-model="end"
            />
          </div>
          <div v-if="selectedCategory == 'REP'" class="input-group">
            <label>Gesamterzeugung im Zeitraum [kWh]</label>
            <input
              type="number"
              placeholder="Bitte geben Sie die Gesamterzeugung im Zeitraum ein"
              class="input-data"
              v-model="totalConsumption"
            />
          </div>
          <div v-else class="input-group">
            <label>Jahresverbrauch [kWh]</label>
            <input
              type="number"
              placeholder="Bitte geben Sie Ihren Jahresverbrauch in kWh ein"
              class="input-data"
              v-model="totalConsumption"
            />
          </div>
        </form>
        <div class="footer">
          <button v-if="selectedCategory == 'SLP'" @click="getSLP">
            Erstellen
          </button>
          <button v-else @click="getREP">Erstellen</button>
        </div>
      </div>
      <div v-else>
        <div
          v-show="
            selectedCategory == 'SLP' && slpSelectedCategory == 'Gasprofil'
          "
        >
          <form>
            <div class="input-group">
              <label>Name</label>
              <input
                type="text"
                placeholder="Name"
                class="input-data"
                v-model="newSlpProfileName"
              />
            </div>
            <div class="input-group">
              <label>Start</label>
              <input type="date" class="input-data1" v-model="startDate" />
            </div>
            <div class="input-group">
              <label>Ende</label>
              <input type="date" class="input-data1" v-model="endDate" />
            </div>
            <div class="input-group">
              <label>Jahresverbrauch [kWh]</label>
              <input
                type="number"
                placeholder="Bitte geben Sie Ihren Jahresverbrauch in kWh ein"
                class="input-data"
                v-model="yearlyConsumption"
              />
            </div>
            <div class="input-group">
              <label>Adresse</label>
              <input
                type="text"
                ref="origin"
                placeholder="Geben Sie eine vollständige Adresse ein"
                class="input-data"
                @input="checkAddressEmpty($event)"
              />
            </div>
            <div class="input-group">
              <label>Strasse</label>
              <input
                type="text"
                class="input-data1 input-disable"
                v-model="street"
                disabled="true"
              />
            </div>
            <div class="input-group">
              <label>Hausnummer</label>
              <input
                type="text"
                v-model="houseno"
                class="input-data1 input-disable"
                disabled="true"
              />
            </div>
            <div class="input-group">
              <label>Ort</label>
              <input
                type="text"
                class="input-data1 input-disable"
                v-model="place"
                disabled="true"
              />
            </div>
            <div class="input-group">
              <label>Postleitzahl</label>
              <input
                type="number"
                class="input-data1 input-disable"
                v-model="zip"
                disabled="true"
              />
            </div>
          </form>
        </div>
        <div class="footer">
          <button @click="getSLP">Erstellen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AmplifyStore from '../store/store';
import LoadingSpinner from './widgets/LoadingSpinner.vue';
import SLPrivateJSONData from '../assets/slpPrivate.json';
import SLBusinessJSONData from '../assets/slpBusiness.json';
import { getSLPData } from '../services/load-profile.services';
import { debouncer } from '../utils/helpers';

export default {
  name: 'SlpProfile',
  data() {
    return {
      profileName: '',
      isLoading: false,
      step: 0,
      profileCategories: [
        {
          id: 'SLP',
          name: 'Verbrauchsprofil',
          img: './profiles.png',
          description: 'Verschiedene typische Verbrauchsprofile.',
          selected: false,
          class: 'category',
        },
        {
          id: 'REP',
          name: 'Erzeugungsprofil',
          img: './renewable.png',
          description: 'Verschiedene typische Erzeugungsprofile.',
          selected: false,
          class: 'category',
        },
      ],
      SLPCategories: [
        {
          id: 'Gasprofil',
          name: 'Gasprofil erstellen',
          img: './profiles.png',
          description: 'Verschiedene typische Verbrauchsprofile.',
          selected: false,
          class: 'newcategory',
        },
        {
          id: 'Stromprofil',
          name: 'Stromprofil erstellen',
          img: './profiles.png',
          description: 'Verschiedene typische Verbrauchsprofile.',
          selected: false,
          class: 'newcategory',
        },
      ],
      slpProfileTypes: [
        {
          id: 'H0',
          label: 'Haushalt',
          img: './home-1.png',
          description: 'Typisches Haushaltsprofil. SLP Profil H0',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G0',
          label: 'Gewerbe',
          description: 'Durchschnittswerte aller Gewerbeprofile. SLP Profil G0',
          img: './shop.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G1',
          label: 'Büro',
          description:
            'Gewerbe mit Öffnungszeiten von 8 bis 18 Uhr in Werktage. SLP Profil G1',
          img: './office-building.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G2',
          label: 'Abendgaststätten',
          description:
            'Gewerbe mit starkem Verbrauch in den Abendstunden. SLP Profil G2',
          img: './bar.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G3',
          label: 'Kühlhaus',
          description: 'Gewerbe mit durchlaufendem Verbrauch. SLP Profil G3',
          img: './warehouse.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G4',
          label: 'Friseur',
          description: 'Typischer Verbrauch eines Friseurladens. SLP Profil G4',
          img: './hairsalon5.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G5',
          label: 'Bäckerei',
          description:
            'Typischer Verbrauch einer Bäckerei mit Backstube. SLP Profil G5',
          img: './baker.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'G6',
          label: 'Kino',
          description: 'Gewerbe mit Wochenendbetrieb. SLP Profil G6',
          img: './movie.png',
          selected: false,
          class: 'SLP',
        },
        /*
        {
          id: 'G7',
          label: 'Mobilfunksendestation',
          description: 'Durchgängiges Bandlastprofil.',
          img: './celular-station.png',
          selected: false,
          class: 'SLP'
        },*/
        {
          id: 'L0',
          label: 'Landwirtschaftsbetrieb',
          description: 'Allgemeiner Landwirtschaftsbetrieb. SLP Profil L0',
          img: './farm.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'L1',
          label: 'Tierzucht',
          description:
            'Landwirtschaftsbetriebe mit Milchwirtschaft/Nebenerwerbs-Tierzucht. SLP Profil L1',
          img: './cow.png',
          selected: false,
          class: 'SLP',
        },
        {
          id: 'L2',
          label: 'Landwirtschaftsbetrieb',
          description: 'Übrige Landwirtschaftsbetriebe. SLP Profil L2',
          img: './fruits.png',
          selected: false,
          class: 'SLP',
        },
      ],
      generatorProfiles: [
        {
          id: '50H',
          label: '50Hertz',
          img: './solar.png',
          description:
            'Basierend auf die Solarenergie die durch den ÜNB 50Hertz vermarktet wurde.',
          selected: false,
          class: 'REP',
        },
        {
          id: 'AMP',
          label: 'Amprion',
          img: './solar.png',
          description:
            'Basierend auf die Solarenergie die durch den ÜNB Amprion vermarktet wurde.',
          selected: false,
          class: 'REP',
        },
        {
          id: 'TEN',
          label: 'TenneT TSO',
          img: './solar.png',
          description:
            'Basierend auf die Solarenergie die durch den ÜNB TenneT TSO vermarktet wurde.',
          selected: false,
          class: 'REP',
        },
        {
          id: 'TRA',
          label: 'TransnetBW',
          img: './solar.png',
          description:
            'Basierend auf die Solarenergie die durch den ÜNB TransnetBW vermarktet wurde.',
          selected: false,
          class: 'REP',
        },
        /*
        {
          id: "ALL_GE",
          label: "Gesamt Deutschland",
          img: "./solar.png",
          description: "Basierend auf die gesamte Solarenergie, die durch den vier ÜNB vermarktet wurde..",
          selected: false,
          class: "REP",
        },
        */
      ],
      name: null,
      state: { name: null, shortName: null },
      statesFilter: null,
      states: [
        { name: 'Baden-Württemberg', shortName: 'BW' },
        { name: 'Bayern', shortName: 'BY' },
        { name: 'Berlin', shortName: 'BE' },
        { name: 'Brandenburg', shortName: 'BB' },
        { name: 'Bremen', shortName: 'HB' },
        { name: 'Hamburg', shortName: 'HH' },
        { name: 'Hessen', shortName: 'HE' },
        { name: 'Mecklenburg-Vorpommern', shortName: 'MV' },
        { name: 'Niedersachsen', shortName: 'NI' },
        { name: 'Nordrhein-Westfalen', shortName: 'NW' },
        { name: 'Rheinland-Pfalz', shortName: 'RP' },
        { name: 'Saarland', shortName: 'SL' },
        { name: 'Sachsen', shortName: 'SN' },
        { name: 'Sachsen-Anhalt', shortName: 'ST' },
        { name: 'Schleswig-Holstein', shortName: 'SH' },
        { name: 'Thüringen', shortName: 'TH' },
        // { name: 'Bundesrepublik Deutschland (DE)', shortName: 'DE' },
      ],
      customerTypeData: { name: 'Privat' },
      customerTypes: [{ name: 'Gewerbe' }, { name: 'Privat' }],
      customerTypeFilter: null,
      BundeslandData: { name: null },
      BundeslandTypes: [
        { name: 'Bundesweit' },
        { name: 'Baden-Württemberg' },
        { name: 'Bayern' },
        { name: 'Berlin' },
        { name: 'Brandenburg' },
        { name: 'Bremen' },
        { name: 'Hamburg' },
        { name: 'Hessen' },
        { name: 'Mecklenburg-Vorpommern' },
        { name: 'Niedersachsen' },
        { name: 'Nordrhein-Westfalen' },
        { name: 'Rheinland-Pfalz' },
        { name: 'Saarland' },
        { name: 'Sachsen' },
        { name: 'Sachsen-Anhalt' },
        { name: 'Schleswig-Holstein' },
        { name: 'Thüringen' },
      ],

      BundeslandFilter: null,
      disableType: {
        customerTypeData: false,
        bundlesData: false,
        profileTypeData: true,
        windData: true,
        frequencyTypeData: true,
      },
      // profile
      profileTypeData: { caption: '', profilecode: '' },
      profileTypes: [],
      profileTypeFilter: null,
      // wind
      windTypeData: { name: '' },
      windTypes: [],
      matchWindData: [
        'hoher Prozessgasanteil',
        'erhöhter Prozessgasanteil',
        'mittlerer Heizgasanteil',
        'erhöhter Heizgasanteil',
        'hoher Heizgasanteil',
      ],
      windTypeDataFilter: null,
      // frequency
      frequencyTypeData: { name: '', value: '' },
      frequencyTypes: [
        { name: 'Täglich', value: 'D' },
        { name: 'Stündlich', value: 'H' },
      ],
      frequencyTypeFilter: null,
      selectStateVisible: false,
      year: new Date().getFullYear() + 1,
      start: new Date().getFullYear() + 1 + '-01-01T00:00',
      end: new Date().getFullYear() + 1 + '-12-31T23:45',
      totalConsumption: 10000,
      slpProfileMetaData: null,
      startDate: null,
      endDate: null,
      yearlyConsumption: null,
      formatted_address: '',
      street: '',
      houseno: null,
      place: '',
      zip: null,
      newSlpProfileName: '',
      showOption: '',
      staticFormData: [
        {
          label: 'Start',
          type: 'date',
          placeholder: '',
          value: this.startDate,
        },
        { label: 'Ende', type: 'date', placeholder: '', value: this.endDate },
        {
          label: 'Jahresverbrauch',
          type: 'number',
          placeholder: 'Jahresverbrauch',
          value: this.yearlyConsumption,
        },
      ],

      addressFormData: [
        {
          label: 'Strasse',
          type: 'text',
          placeholder: 'Strasse',
          value: this.street,
        },
        {
          label: 'Hausnummer',
          type: 'number',
          placeholder: 'Hausnummer',
          value: this.houseno,
        },
        {
          label: 'Ort',
          type: 'text',
          placeholder: 'Ort',
          value: this.place,
        },
        {
          label: 'Postleizahl',
          type: 'number',
          placeholder: 'Postleizahl',
          value: this.zip,
        },
      ],
    };
  },
  props: {
    database: Object,
  },
  methods: {
    close() {
      this.goBackToStep(0);
      this.$emit('close', null);
    },
    getImgUrl: function (img) {
      if (img) {
        var images = require.context('../assets/img/', false, /\.png$/);
        return images(img);
      } else return '';
    },
    returnSLP: function () {
      this.slpProfileMetaData = {
        name: this.name,
        state: this.state.shortName,
        year: this.year,
        Code: this.selectedSLP,
        totalConsumption: this.totalConsumption,
      };
      this.$emit('close', this.slpProfileMetaData);
    },
    getSlpTypeData: function () {
      if (
        this.customerTypeData.name == '' ||
        this.BundeslandData.name == '' ||
        this.profileTypeData.caption == '' ||
        this.windTypeData.name == '' ||
        this.frequencyTypeData.name == ''
      ) {
        this.showToaster(
          'Bitte wählen Sie alle Optionen aus!',
          'Fehler',
          'danger'
        );
        return;
      }
      this.nextStep(3, null);
      this.newSlpProfileName = `SLP_${this.profileTypeData.profilecode}_${this.BundeslandData.name}_${this.profileTypeData.caption}`;

      // google place api call
      const isAlreadyScriptExists = document.getElementById('mapsapi');
      fetch(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCpTnvkKqiiua2Zuy7z5gSu7KtsABfnoIE&libraries=places&language=de'
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then((scriptText) => {
          if (!isAlreadyScriptExists) {
            const script = document.createElement('script');
            script.id = 'mapsapi';
            script.textContent = scriptText;
            document.head.appendChild(script);
          }
          this.getPlaces();
        })
        .catch((error) => {
          console.error('There was a problem fetching the script:', error);
        });
    },
    getSLP: async function () {
      let url = '';
      try {
        if (
          this.selectedCategory == 'SLP' &&
          this.slpSelectedCategory == 'Gasprofil'
        ) {
          if (
            this.newSlpProfileName.trim() === '' ||
            this.startDate === null ||
            this.startDate.trim() === '' ||
            this.endDate === null ||
            this.endDate.trim() === '' ||
            this.yearlyConsumption == null ||
            this.yearlyConsumption.trim() == '' ||
            this.formatted_address.trim() == '' ||
            this.street.trim() === '' ||
            this.houseno == null ||
            this.houseno.trim() == '' ||
            this.place.trim() === '' ||
            this.zip === null ||
            this.zip.trim() === ''
          ) {
            this.showToaster(
              'Bitte wählen Sie alle Felder aus!',
              'Fehler',
              'danger'
            );
            return;
          } else {
            url = `/slp-gas-profile?name=${this.newSlpProfileName}&start=${this.startDate}&end=${this.endDate}&profile_code=${this.profileTypeData.profilecode}&address=${this.formatted_address}&customer_type=${this.customerTypeData.name}&consumptionvalue=${this.yearlyConsumption}&freq=${this.frequencyTypeData.value}&yearly_consumption_or_customer_value=yearly_consumption`;
          }
        } else {
          if (
            this.profileName.trim() === '' ||
            !this.year ||
            String(this.year).trim() === '' ||
            !this.state.shortName ||
            this.state.shortName.trim() === '' ||
            String(this.totalConsumption).trim() === ''
          ) {
            this.showToaster(
              'Bitte wählen Sie alle Felder aus!',
              'Fehler',
              'danger'
            );
            return;
          }
          url = `/slp-profile?state=${this.state.shortName}&year=${
            this.year
          }&profile_code=${this.selectedSLP}&total_consumption=${
            this.totalConsumption
          }
        &name=${this.profileName.replace(
          '{Bundesland}',
          this.state.shortName
        )}`;
        }

        this.isLoading = true;
        // Create name
        let ts = new Date().getTime();
        let id =
          this.user.username +
          '/output/' +
          this.database.name +
          '::sheet_0_' +
          ts;
        // trigger putElement in parent

        await this.$emit('slpPreview', id, 'SLP Profil');
        const response = await getSLPData(url);
        const data = response.data;
        if (data) {
          data.id = id;
          this.$emit('close', data);
          this.Loading = false;
        }
      } catch (error) {
        this.Loading = false;
      }
    },
    getREP: async function () {
      // Convert times for API
      let start = new Date(this.start).getTime();
      let end = new Date(this.end).getTime();

      // loading screen
      this.isLoading = true;

      // get api end point
      var url = process.env.VUE_APP_SLP_GENERATOR_API;

      // add function name
      url += '/renewable-energy-profile';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      // API params
      url += '?start=' + encodeURIComponent(start);
      url += '&end=' + encodeURIComponent(end);
      url += '&profile_code=' + this.selectedREP;
      url += '&total_consumption=' + this.totalConsumption;
      url += '&name=' + this.profileName;

      // Create name
      let ts = new Date().getTime();
      let id =
        this.user.username +
        '/output/' +
        this.database.name +
        '::sheet_0_' +
        ts;

      // trigger putElement in parent
      await this.$emit('slpPreview', id, 'REP Profil');

      fetch(url, {
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == 200) return response.clone().json();
          else if (response.status == 401)
            throw new Error('Access Token has expired');
          else throw new Error('CORS');
        })
        .then((data) => {
          data.id = id;
          this.$emit('close', data);
        })
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else if (e == 'Error: CORS') this.$emit('close', 'showError');
        });
    },

    select(p, id) {
      if (p.class == 'category') {
        this.profileCategories.forEach((p, idx) => {
          if (idx === id) {
            this.profileName = p.name;
          }
          p.selected = false;
        });
      } else if (p.class == 'newcategory') {
        this.SLPCategories.forEach((p, idx) => {
          p.selected = false;
        });
      } else if (p.class == 'SLP') {
        this.slpProfileTypes.forEach((p, idx) => {
          if (idx === id) {
            this.profileName = `SLP_${p.id}_{Bundesland}_${p.label}`;
          }
          p.selected = false;
        });
      } else {
        this.generatorProfiles.forEach((p, idx) => {
          if (idx === id) {
            this.profileName = `Erzeugungsprofil_${p.label}`.replace(' ', '_');
          }
          p.selected = false;
        });
      }

      p.selected = true;
    },
    hideSelectState: function () {
      this.statesFilter = null;
      this.selectStateVisible = false;
    },
    showSelectState: function () {
      this.selectStateVisible = true;
    },
    customOptionSelect: function (option) {
      this.showOption = option;
      this.customerTypeFilter = null;
      this.profileTypeFilter = null;
      this.BundeslandFilter = null;
      this.windTypeDataFilter = null;
      this.frequencyTypeFilter = null;
    },

    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    setState: function (state) {
      // Set state
      this.state = JSON.parse(JSON.stringify(state));

      // Replace state in name, if default format
      if (this.profileName.includes('{Bundesland}'))
        this.profileName = this.profileName.replace(
          '{Bundesland}',
          state.shortName
        );
      else {
        this.states.forEach(
          (e) =>
            (this.profileName = this.profileName.replace(
              `_${e.shortName}_`,
              `_${state.shortName}_`
            ))
        );
      }

      this.hideSelectState();
    },
    customDropDownFunction: function (selectedData, type) {
      if (type === 'Kundentyp') {
        this.customerTypeData.name = selectedData.name;
        if (this.customerTypeData.name == 'Gewerbe') {
          this.BundeslandData.name = 'Bundesweit';
          // select business type
          this.profileTypes = this.businesssCombination;
          //disable bundles for business
          this.disableType.bundlesData = true;
          //enable profile
          this.disableType.profileTypeData = false;
        } else {
          //again back to user select remove remaining below
          this.profileTypes = [];
          this.disableType.bundlesData = false;
          this.BundeslandData.name = '';
          this.BundeslandFilter = null;
          this.emptyProfileTypes();
          this.disableType.profileTypeData = true;
        }

        if (this.customerTypeData.name != this.customerTypeFilter) {
          this.emptyProfileTypes();
          this.emptyWindTypes();
        }

        this.showOption = '';
        this.customerTypeFilter = this.customerTypeData.name;
      } else if (type === 'Bundesland') {
        if (this.BundeslandData.name != this.BundeslandFilter) {
          this.emptyProfileTypes();
          this.emptyWindTypes();
        }
        this.profileTypes = this.privateCombination(selectedData.name);
        // always to select for privatecombination
        this.BundeslandData.name = selectedData.name;
        //enable profiletype
        this.disableType.profileTypeData = false;

        this.BundeslandFilter = this.BundeslandData.name;
        this.showOption = '';
      } else if (type === 'Profiltyp') {
        this.profileTypeData.caption = selectedData.caption;
        this.profileTypeData.profilecode = selectedData.profilecode;
        //enable windtype data
        this.disableType.windData = false;
        //again back to use select to remove remainnig pre selected and

        if (this.profileTypeData.caption != this.profileTypeFilter) {
          this.emptyWindTypes();

          //match num_fac selected array to windMatchdata its array so make windTypes correspoinds
          selectedData.num_fac.map((num) => {
            if (this.matchWindData[num - 1] && num > 0)
              this.windTypes.push({
                name: this.matchWindData[num - 1],
                number: num,
              });
          });
        }
        this.profileTypeFilter = this.profileTypeData.caption;
        this.showOption = '';
      } else if (type === 'Windstärke/Heizung') {
        this.windTypeData.name = selectedData.name;
        const selectedWind = this.windTypes.find(
          (data) => data.name === selectedData.name
        );
        let match = this.profileTypeData.profilecode.match(/\{fac\}/g);
        if (match !== null) {
          this.profileTypeData.profilecode =
            this.profileTypeData.profilecode.replace(
              /\{fac\}/,
              selectedWind.number
            );
        } else {
          this.profileTypeData.profilecode =
            this.profileTypeData.profilecode.slice(0, 2) +
            selectedWind.number +
            this.profileTypeData.profilecode.slice(3);
        }

        // enable freq type
        this.disableType.frequencyTypeData = false;
        this.windTypeDataFilter = this.windTypeData.name;
        this.showOption = '';
      } else if (type === 'Frequenz') {
        this.frequencyTypeData.name = selectedData.name;
        this.frequencyTypeData.value = selectedData.value;
        this.frequencyTypeFilter = this.frequencyTypeData.name;
        this.showOption = '';
      }
    },
    goBackToStep(step) {
      if (step > 0) this.step = step - 1;
      if (this.selectedCategory === 'REP' && step == 2) this.step = 0;
      if (step == 1) {
        this.profileCategories = this.profileCategories.map((profile) => ({
          ...profile,
          selected: false,
        }));
      } else if (step == 1 || step == 2) {
        this.SLPCategories = this.SLPCategories.map((profile) => ({
          ...profile,
          selected: false,
        }));
      }
    },
    nextStep(step, categoryData) {
      if (categoryData != null) {
        categoryData.selected = true;
        if (categoryData.id === 'REP') step = 2;
      }
      this.step = step;
      if (step === 3) {
        this.totalConsumption = this.selectedCategory !== 'REP' ? '' : 10000;
      }
    },

    async getPlaces() {
      const google = window.google;
      const autocomplete = new google.maps.places.Autocomplete(
        this.$refs.origin
      );
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        this.formatted_address = place.formatted_address;
        if (!place.geometry) {
          return;
        }
        let addressComponents = place.address_components;
        let street = '';
        let streetNumber = '';
        let postalCode = '';
        let city = '';
        for (let i = 0; i < addressComponents.length; i++) {
          let component = addressComponents[i];
          let componentType = component.types[0];
          if (componentType === 'route') {
            street = component.long_name;
          } else if (componentType === 'street_number') {
            streetNumber = component.long_name;
          } else if (componentType === 'postal_code') {
            postalCode = component.long_name;
          } else if (componentType === 'locality') {
            city = component.long_name;
          }
        }
        this.street = street;
        this.zip = postalCode;
        this.houseno = streetNumber;
        this.place = city;
      });
    },

    customDataFiltered(types, filterArray, filterData) {
      const res = filterArray.filter((f) => {
        if (filterData) {
          if (types !== 'profile')
            return f.name.toLowerCase().indexOf(filterData.toLowerCase()) > -1;
          else
            return (
              f.caption.toLowerCase().indexOf(filterData.toLowerCase()) > -1
            );
        } else return filterArray;
      });

      return res;
    },
    checkAddressEmpty(e) {
      if (e.target.value.trim() === '') {
        this.street = '';
        this.houseno = '';
        this.place = '';
        this.zip = '';
      }
    },
    emptyProfileTypes() {
      this.profileTypeData.caption = '';
      this.profileTypeData.profilecode = '';
      this.profileTypeFilter = '';
      this.disableType.windData = true;
    },
    emptyWindTypes() {
      this.windTypeData.name = '';
      this.windTypeDataFilter = '';
      this.windTypes = [];
    },
    privateCombination(bundeslandSelectedType) {
      const uniquePrivateObject = {};
      let num_fac = [];

      const matchData = SLPrivateJSONData.filter((data) => {
        return data.data === bundeslandSelectedType;
      });

      matchData.map((data, idx) => {
        const { caption, value_api } = data;
        if (!uniquePrivateObject[caption]) {
          const formatted_api_value = value_api.slice(0, 2) + '{fac}_syn';
          const profilecode = formatted_api_value;
          uniquePrivateObject[caption] = {
            caption,
            profilecode,
            num_fac,
          };
          if (idx != 0) num_fac = [];
        }
        const str = value_api;
        const digit = parseInt(str[2]);
        num_fac.push(digit);
      });

      return Object.values(uniquePrivateObject);
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
  },

  created() {
    // Add class to make background fixed
    this.goBackToStep(0);
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },

  computed: {
    selectedCategory() {
      var id;
      var isSelected =
        this.profileCategories.filter((e) => e.selected).length > 0;
      if (isSelected)
        id = this.profileCategories.filter((e) => e.selected)[0].id;
      return id;
    },
    selectedSLP() {
      var id;
      var isSelected =
        this.slpProfileTypes.filter((e) => e.selected).length > 0;
      if (isSelected) id = this.slpProfileTypes.filter((e) => e.selected)[0].id;
      return id;
    },
    selectedREP() {
      var id;
      var isSelected =
        this.generatorProfiles.filter((e) => e.selected).length > 0;
      if (isSelected)
        id = this.generatorProfiles.filter((e) => e.selected)[0].id;
      return id;
    },
    user() {
      return AmplifyStore.state.user;
    },
    slpSelectedCategory() {
      return this.SLPCategories.find((e) => e.selected)?.id;
    },

    businesssCombination() {
      const uniqueBusinessObject = {};
      let num_fac = [];
      SLBusinessJSONData.map((data, idx) => {
        const { caption, value_api } = data;
        if (!uniqueBusinessObject[caption]) {
          const formatted_api_value = value_api.slice(0, 2) + '{fac}_syn';
          const profilecode = formatted_api_value;
          const num_fac = [1, 2, 3, 4, 5];
          uniqueBusinessObject[caption] = {
            caption,
            profilecode,
            num_fac,
          };
        }
      });
      return Object.values(uniqueBusinessObject);
    },
  },
  components: {
    LoadingSpinner,
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');

          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-fullscreen.modal-window:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 60%);
  z-index: 1;
}

.modal-fullscreen.modal-window {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  background: transparent;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
  z-index: 1000;
}

.modal-fullscreen.modal-window .modal {
  width: 70%;
  margin: 0 auto;
  background: #fff;
  display: block;
  position: relative;
  top: unset;
  left: unset;
  height: 100%;
  max-height: 95vh;
  min-height: 95vh;
  border-radius: 5px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .modal-fullscreen {
  padding: 20px;
  background: #ffffff;
  display: block;
  width: 100%;
  height: 900px;
  text-align: center;
  margin-left: -14px;
  top: 0;
} */

.modal {
  overflow: auto;
  display: unset;
  z-index: 1;
}

h1 {
  padding-top: 60px;
  color: #313745;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.12px;
  line-height: 41px;
  text-align: center;
  display: block;
  width: 860px;
  margin: 0 auto 40px;
  border: 0;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: relative;
  z-index: 1;
  -webkit-font-smoothing: antialiased;
  text-transform: none;
  margin-bottom: 20px;
  font-size: 38px;
  padding-bottom: 6px;
}

h2 {
  color: #313745;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.16px;
  line-height: 19px;
  padding-bottom: 55px;
}

.group-wrapper {
  overflow: auto;
}

.modal > form {
  margin: 0 20%;
}

.modal > form > h3 {
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 16px;
  text-align: left;
  margin-top: 35px;
}

.modal > h4 {
  color: rgba(85, 93, 109, 0.4);
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding-bottom: 55px;
}

input {
  float: none;
  text-align: center;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding: 15px 20px 15px 20px;
  width: 290px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 52px;
  width: 100%;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #7e8890;
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.23px;
  line-height: 20px;
  padding: 15px 20px 15px 20px;
  text-align: left;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

::placeholder {
  color: #e3e3e3;
  opacity: 1;
}

button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

.input-group > button {
  margin: 40px auto 0;
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  position: relative;
  margin-top: 15px;
  z-index: 2;
}

.pull-left {
  float: left;
  z-index: 2;
  height: 30px;
  margin-top: 10px;
  margin-left: 15px;
  position: fixed;
}

.modal .btn-back {
  width: 23px;
  cursor: pointer;
}

.item {
  height: 175px;
}

.group-wrapper .item {
  height: 175px;
}

.group-wrapper {
  max-width: 960px;
  margin: 0 auto 0px;
  text-align: center;
  margin-top: 5px;
  overflow: auto;
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
}

.group-wrapper.category {
  width: 500px;
}

.group-wrapper.customer-profile {
  height: calc(100% - (107px + 74px + 8px + 100px + 40px));
}

.group-wrapper.category.big {
  width: fit-content;
  margin-bottom: 29px;
}

.group-wrapper.big .item-wrapper .img-wrapper {
  height: 200px;
  margin-top: 80px;
  margin-bottom: 28px;
}

.group-wrapper.big .item-wrapper .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper:hover .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper:hover {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper .img-wrapper {
  filter: grayscale(82%) hue-rotate(246deg) opacity(30%);
}

.group-wrapper.big .item-wrapper {
  width: 315px;
  height: 482px;
  margin: 37px;
}

.group-wrapper .item-wrapper {
  display: inline-block;
  width: 212px;
  height: 230px;
  margin: 10px;
  opacity: 1;
  cursor: pointer;
  text-align: -webkit-match-parent;
  box-shadow: none;
  overflow: hidden;
}

.group-wrapper .img-wrapper {
  width: 100%;
  height: 130px;
}

.group-wrapper input {
  display: initial;
}

.group-wrapper .icon {
  position: absolute;
  width: 43%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: none;
  background-color: #fff;
  padding: 18px 6px 8px 6px;
}

.group-wrapper.big .icon {
  width: 300px;
}

.group-wrapper .item-wrapper h2 {
  color: #434c5e;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.16px;
  line-height: 19px;
  padding-bottom: 0px;
}

.footer {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  height: 100px;
}

button {
  display: block;
  width: 180px;
  height: 44px;
  margin: 0 auto 80px;
  background: none;
  border: 0;
  border-radius: 100px;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  color: inherit;
  letter-spacing: 1px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
  cursor: pointer;
  border: 1px solid #ccc;
}

.footer > button {
  background: #fb3467;
  color: #fff;
  border: none;
  margin-top: 20px;
}

.footer > button.disabled {
  background-color: rgba(224, 0, 90, 0.3);
  cursor: unset;
}

.group-wrapper .item-wrapper .description {
  font-family: 'SF UI Text', -apple-system, system-ui, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  text-transform: none;
  color: #7b8496;
  -webkit-font-smoothing: antialiased;
  max-width: 100%;
  margin: 0px 13px 0px 13px;
  opacity: 0;
  transform: translateY(15px);
  transition: 0.2s ease;
}

.group-wrapper.big .item-wrapper .description {
  transform: translateY(5px);
  opacity: 1;
  margin-bottom: 25px;
}

.group-wrapper.big .item-wrapper:hover .description {
  transform: translateY(0);
  opacity: 1;
  margin-bottom: 15px;
}

.group-wrapper .item-wrapper:hover .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.group-wrapper .item-wrapper.active .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.slp-profile .toggle-list-wrapper {
  width: 100%;
  left: 0px;
  max-width: unset;
  padding-top: 10px;
  top: 71px;
  max-height: 260px;
  position: absolute;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 10px 20px rgba(0, 0, 0, 0.15);
  overflow: scroll;
  background-color: #fff;
  z-index: 2;
  border-radius: 3px;
}

.toggle-list-wrapper .item {
  height: fit-content;
  padding: 0.5px 23px;
}

.toggle-list-wrapper .item .label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  font-size: 14px;
}

input {
  cursor: text;
}

.modal-fullscreen .loading {
  background-color: #ffff;
  position: fixed;
  height: 80%;
  width: 70%;
  top: 7%;
  z-index: 3;
}

.progress-icon {
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 250px;
  width: 70px;
  height: 70px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

input[type='datetime-local']::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 5%;
  padding-left: 90%;
  cursor: pointer;
}

.modal.custom-loading .loading {
  top: 50%;
  left: unset;
  max-height: 95vh;
  min-height: 95vh;
  position: fixed;
  z-index: 3;
  width: 70%;
  display: block;
  border-radius: 5px;
  transform: translateY(-50%);
}

.modal.custom-loading {
  overflow: hidden;
}

::v-deep .modal.custom-loading .progress-icon-wrapper {
  bottom: 0;
  width: auto;
}
.generator h2,
.consumption h2 {
  text-align: center;
}

.modal-fullscreen .modal .btn-close-container {
  float: right;
  position: relative;
  margin-top: 15px;
  z-index: 2;
  margin-right: 15px;
}

.modal-fullscreen .modal .consumption.profiles {
  height: 100%;
}
.modal-fullscreen .modal .btn-close-container.step-one {
  margin-right: 8px;
}
.modal form {
  margin: 0 20%;
}
.modal form input.input-disable:disabled {
  background-color: #dddddd;
}

.modal form input.input-disable::placeholder {
  color: #adb5c7;
}

.modal form input.input-data {
  font-size: 28px;
}
.modal form input.input-data1 {
  font-size: 23px;
}
</style>
